import { gql } from '@/__generated__';

const GET_USER_PROFILE = gql(`#graphql
  query GetUserProfile($id: Int!) {
    user(id: $id) {
      id
      name
      lastnames
      picture
      email
      phone
      twoFactorAuth
      fullName
      createdAt
      mainOrganization {
        organization {
          id
          name
          photo
        }
        role {
          id
          name
        }
      }
      additionalOrganizations {
        organization {
          id
          name
          photo
        }
        role {
          id
          name
        }
      }
      temporaryUser {
        activationToken
        activationTokenExpiration
        temporaryUserDurationDays
        temporaryUserExpiration
      }
    }
  }
`);

export default GET_USER_PROFILE;
